import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CalendarModule } from 'primeng/calendar';
import { InputMaskModule } from 'primeng/inputmask';

const importsAndExports = [CalendarModule, InputMaskModule];
@NgModule({
  imports: [CommonModule, ...importsAndExports],
  declarations: [],
  exports: [...importsAndExports],
})
export class PrimengSharedModule {}
